import { api } from "@/lib/api";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { getAccommodationWithFulfillmentsQueryOptions } from "../accommodations";
import { getAllReservationServicesWithFulfillmentsQueryOptions } from "../reservation-services";
import { useToast } from "../use-toast";

export function useDeleteFulfillment(opts?: {
  onSuccess?: () => void;
  onError?: () => void;
}) {
  const queryClient = useQueryClient();
  const { toast } = useToast();

  return useMutation({
    mutationFn: async ({
      id,
    }: {
      id: string;
      reservationId: string;
      type: "accommodation" | "service";
    }) => {
      await api.delete<void>(`/api/fulfillments/$id`, undefined, {
        pathReplace: { $id: id },
      });
    },
    onSuccess: (_, { id, reservationId, type }) => {
      if (type === "accommodation") {
        queryClient.setQueryData(
          getAccommodationWithFulfillmentsQueryOptions(reservationId).queryKey,
          (old) =>
            old?.map((a) => ({
              ...a,
              fulfillments: a.fulfillments?.filter((f) => f.id !== id),
            })),
        );
      }
      if (type === "service") {
        queryClient.setQueryData(
          getAllReservationServicesWithFulfillmentsQueryOptions(reservationId)
            .queryKey,
          (old) =>
            old?.map((s) => ({
              ...s,
              fulfillments: s.fulfillments?.filter((f) => f.id !== id),
            })),
        );
      }
      toast({
        title: "toast.fulfillmentDeleted",
        variant: "success",
      });
      opts?.onSuccess?.();
    },
    onError: () => {
      toast({
        title: "toast.deleteFulfillmentError",
        variant: "destructive",
      });
      opts?.onError?.();
    },
  });
}
